import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "diamond"
const DiamondIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.375 2.625C18.645 2.625 18.895 2.771 19.028 3.007L22.654 9.452 12.582 21.848C12.44 22.023 12.226 22.125 12 22.125S11.56 22.023 11.418 21.848L1.346 9.452 4.972 3.007 5.027 2.923C5.167 2.737 5.387 2.625 5.625 2.625zM11.25 19.262V10.125H3.826zM12.75 19.262 20.174 10.125H12.75zM9.907 8.625H14.093L12 4.904zM16.589 8.625H20.469L18.413 4.973zM3.532 8.625H7.412L5.584 4.973zM8.664 7.776 10.718 4.125H6.838zM15.335 7.776 17.161 4.125H13.281z" />
        </svg>
      }
    </span>
  )
}
export default DiamondIcon
